export default "skymp5-front/a930d5721a9b7c86fc99ebd08b8a57c8.gif";